import Vue from 'vue';

import { END_POINTS } from '@/enums';

import API from './index';

const END_POINT = END_POINTS.USERS;

export default {
  async getRewards(
    restaurantId: number
  ): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/rewards/${restaurantId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/rewards`, err.response.data);
      throw err.response.data;
    }
  },
  async getFavoriteLocations(): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/locations`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getFavoriteLocations`, err.response.data);
      throw err.response.data;
    }
  },
  async getFavoriteOrders(): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/orders/favorites`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getFavoriteOrders`, err);
      return {};
    }
  },
  async addFavoriteLocation(restaurantId, isDefault): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/locations/${restaurantId}?isDefault=${isDefault}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/addFavoriteLocation`, err.response.data);
      throw err.response.data;
    }
  },
  async addFavoriteOrder(addFavoriteOrderRequest: AddFavoriteOrderRequest): Promise<FavoriteOrderModel[]> {
    try {
      return (await API.post(`${END_POINT}/orders/favorites`, addFavoriteOrderRequest)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/addFavoriteOrder`, err.response.data);
      throw err.response.data;
    }
  },
  async removeFavoriteLocation(favoriteId): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/locations/${favoriteId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/removeFavoriteLocation`, err.response.data);
      throw err.response.data;
    }
  },
  async removeFavoriteOrder(faveId: number): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/orders/favorites/${faveId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/removeFavoriteOrder`, err.response.data);
      throw err.response.data;
    }
  },
  async removeBillingAccount(billingAccountId): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/accounts/${billingAccountId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/removeBillingAccount`, err.response.data);
      throw err.response.data;
    }
  },
  async removeDeliveryAddress(addressId): Promise<any> {
    try {
      return (await API.delete(`${END_POINT}/addresses/${addressId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/removeDeliveryAddress`, err.response.data);
      throw err.response.data;
    }
  },
  async setDefaultDeliveryAddress(addressId): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/addresses/${addressId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/setDefaultDeliveryAddress`, err.response.data);
      throw err.response.data;
    }
  },
  async submitClaimRewardRequest(request: ClaimRewardRequest): Promise<any> {
    try {
      return (await API.post(`${END_POINT}/loyalty-claim`, request)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/loyalty-claim`, err.response.data);
      throw err.response.data;
    }
  },
  async getBillingAccounts(basketId: string): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/billing-accounts/${basketId}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/billing-accoutns`, err.response.data);
      throw err.response.data;
    }
  },
}
